import actions from './actions';
import getters from './getters'
import mutations from './mutations';


const getDefaultState = () => ({
  cmsProviders : [],
  loading : false,
  outDated : true,
  currentPage : 1,
  totalPages : 0,
  totalProducts: 0,
  limit:50,
  search : '',
  publishedFilter: null,
  portausCompanyIdsFilter: [],
  hasLogoFilter: null,
  hasMainImageFilter: null,
  filters : {

  },
  sort_icon : 'el-icon-caret-bottom',
  icons : {
    'DESC' : 'el-icon-caret-bottom',
    'ASC' : 'el-icon-caret-top'
  },
  orderBy:{orderName : 'updated_at',  direction:'DESC'},
  selectedCreditNote : null

});

export default {
  namespaced: true,
  state: getDefaultState(),
  actions,
  getters,
  mutations,
  getDefaultState,
};
